import { Stack, Typography, Box } from '@mui/material';
import { useClient } from '../../../../context/ClientContext';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClientOptionButton } from '../../common/ClientOptionButton';
import StepsHeading from '../../common/StepsHeading';


export default function IsSymptom({ userData, setUserData, onNext }) {
    const { theme,clientId } = useClient();
    const navigate = useNavigate();
    const [isExperiencingHealthSymptom, setIsExperiencingHealthSymptom] = useState(() => {
        const storedValue = localStorage.getItem('isExperiencingHealthSymptom');
        if (storedValue === null) {
            return "";
        } else {
            return storedValue === 'true'; // returns true if value is 'true', false otherwise
        }
    });
    //   const handleOptionSelect = ( field, value ) => {
    //     setUserData( { ...userData, [ field ]: value } );
    //     // Call onNext directly after selection to move to the next step
    //     onNext();
    //   };

    const handleOptionSelect = (value) => {
        setIsExperiencingHealthSymptom(value);
        if (value) {
            onNext();
        } else {
            // navigate('/hellohealth-health-profile');
            navigate( `/${ clientId }-health-profile` );
            localStorage.removeItem('symptomDesc');
            // handleEmptySymptoms();
        }
        localStorage.setItem('isExperiencingHealthSymptom', value);
    };

    return (
        <Stack
            spacing={2}
            sx={{
                width: '100%',
                maxWidth: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden'
            }}
        >
            <StepsHeading title={"Are you experiencing any health symptoms?"} />
            {[
                { label: "Yes", value: true },
                { label: "No", value: false },
            ].map((option, index) => (
                <ClientOptionButton
                    optionSelectSingleValue={isExperiencingHealthSymptom}  // Pass the current selected value
                    value={option.value}  // Pass value to compare with userData
                    key={index}
                    option={option.label}
                    onClick={() => handleOptionSelect(option.value)}
                />
            ))}
        </Stack>
    );
}